export const MODULE_REGISTRATION = '/module/registration'
